let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("6wr18"), load("ffEVr"), load("72780"), load("jDjSj"), load("kO0mz")]).then(() => parcelRequire('kYM3c'));